/**
 * Main Entry Point
 * Configures Kinde authentication provider and app initialization
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { KindeProvider } from '@kinde-oss/kinde-auth-react';
import { kindeConfig } from './core/auth/kindeClient';
import { ToastProvider } from './shared/components/Toast';
import { App } from './App';
import { initRum } from './shared/observability/rum';
import { initDatadogLogs, createDatadogLogSink } from './shared/observability/datadogLogs';
import { registerLogSink } from './shared/observability/frontendLogger';
import { startConsoleCapture } from './shared/observability/consoleCapture';
import { setupGlobalErrorHandlers } from './shared/observability/globalErrorHandlers';
import './styles/globals.css';

initRum();
initDatadogLogs();
registerLogSink(createDatadogLogSink());
startConsoleCapture();
setupGlobalErrorHandlers();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <KindeProvider
        clientId={kindeConfig.clientId}
        domain={kindeConfig.domain}
        redirectUri={kindeConfig.redirectUri}
        logoutUri={kindeConfig.logoutUri}
        scope="openid profile email offline"
      >
        <ToastProvider>
          <App />
        </ToastProvider>
      </KindeProvider>
    </BrowserRouter>
  </StrictMode>,
);
